"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = exports.AlertRealTimeEvents = exports.alertsExtractor = void 0;
var alertsExtractor = function (_a) {
    var alerts = _a.alerts;
    return alerts;
};
exports.alertsExtractor = alertsExtractor;
var AlertRealTimeEvents;
(function (AlertRealTimeEvents) {
    AlertRealTimeEvents["CREATED"] = "new alert";
    AlertRealTimeEvents["DELETED"] = "remove alert";
    AlertRealTimeEvents["UPDATED_OWNERSHIP"] = "alert ownership updated";
})(AlertRealTimeEvents = exports.AlertRealTimeEvents || (exports.AlertRealTimeEvents = {}));
var baseRoute = '/alerts';
exports.Routes = {
    GET_ALL: "".concat(baseRoute),
    DISMISS: "".concat(baseRoute, "/{:uuid}"),
    BATCH_DISMISS: "".concat(baseRoute, "/dismiss_by_ids"),
    UPDATE_OWNERSHIP: "".concat(baseRoute, "/ownership")
};
//# sourceMappingURL=Alerts.consts.js.map